import AvatarImage from "../AvatarImage";
import styles from "./avatar.module.css";

export default function Avatar({ uid, big, className = "" }) {
  return (
    <div
      className={`${styles["avatar"]} ${className}`}
      data-testid="profileAvatar"
    >
      <AvatarImage big={big} uid={uid} />
    </div>
  );
}
